import React, { useState, useEffect } from "react"
import "./modal-detail-comment.scss"
import { useStaticQuery, graphql } from "gatsby"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"

const ModalDetailComment = props => {
  const [tempValueLike, settempValueLike] = useState(0)
  const {
    setModalActive,
    question,
    answer,
    titleDoctor,
    currentActiveModal,
    handleShowModal,
    mobile,
    imgConsulting,
    consultationId,
    consultationTopic,
    recomendations,
    // localLikes,
    handleLike,
    likeState,
    slug,
  } = props

  const userInfoEncrypt= encryptUserInfo()
  const viewCounsultedDatalayer = (action, type, like=false) => {
    let titulo= props.slug.split('/')[0] === 'psicologa' ? 'Psicóloga' : 'Ginecóloga'
    if (like) {
      pushDataLayerEvent({
        event: `Interacciones - Consultorio ${titulo}`,
        category: "entre nosotras",
        action: action,
        label: type,
        sub_category: 'Consultorios',
        query_type: consultationTopic,
        likes: recomendations,
        location: window.location.href,
        user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
        log_status: userInfoEncrypt.log_status,
      })
    } else {
      pushDataLayerEvent({
        event: `Interacciones - Consultorio ${titulo}`,
        category: "entre nosotras",
        action: action,
        label: type,
        sub_category: 'Consultorios',
        query_type: consultationTopic, 
        likes: recomendations,
        location: window.location.href,
        user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
        log_status: userInfoEncrypt.log_status,
      })
    }
  }

  useEffect(() => {
    settempValueLike(likeState)
    viewCounsultedDatalayer( 'view', question)
  }, [])
  useEffect(() => {
    const products = JSON.parse(localStorage.getItem("LOCAL_PRODUCT_LIKES"))
    const isLiked = products ? products.filter((element) => element.idProduct === consultationId) : null
    isLiked ? settempValueLike(isLiked[0] ? isLiked[0].likeState : 0) : settempValueLike(0)
  }, [question])


  const handleCloseModal = () => {
    var body = document.getElementsByTagName("body")[0]
    var html = document.getElementsByTagName("html")[0]
    body.classList.remove("overflow-body-hidden")
    html.classList.remove("overflow-body-hidden")
    setModalActive(null)
  }

  const resultQuery = useStaticQuery(
    graphql`
        query IMG_ANOM {
            allContentfulNolHomeTercerNivel(
                filter: { slug: { in: ["consultorios", "consultorios/"] } }
            ) {
                nodes {
                    node_locale
                    imagenUsuariaAnonima {
                        file {
                            url
                        }
                        description
                    }
                }
            }
        }
    `,
  )

  const getColorBkg = slugParam => {
    switch (slugParam) {
      case "ginecologa":
        return "purple"
      case "sexologa":
        return "pink"
      case "psicologa":
        return "blue"
      case "loving":
        return "black"
      default:
        return "blue"
    }
  }

  var anomIMG = resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(
    e => e.node_locale === process.env.LOCALE,
  )[0].imagenUsuariaAnonima

  return (
    <div className="f-curtain-detail-comment">
      <div className="f-modal-detail-comment">
        <div className="f-title-modal-container">
          <label className="f-title-outside">Pregúntale a la </label>
          <span className="f-bold-chewy">{titleDoctor}</span>
        </div>

        <div className="f-question-container">
          <img
            className="f-question-img f-img-comment"
            src={anomIMG.file.url}
            alt={anomIMG.description}
          />

          <div className="f-question-text-container">
            <p className="f-question">{question}</p>
          </div>
        </div>

        <div className="f-answer-container">
          <div className="f-answer-text-container">
            <p className="f-answer">{answer}</p>
          </div>

          <img
            className={"f-answer-img f-img-comment " + getColorBkg(slug)}
            src={imgConsulting.file.url}
            alt={imgConsulting.description}
          />
        </div>
        <div className="f-buttons-container">
          <div
            className={
              "f-fake-button f-like-button " +
              (tempValueLike === 1 ? "f-active" : "")
            }
            onClick={() => {
              handleLike(consultationId, 1)
              settempValueLike(1)
              viewCounsultedDatalayer('click','¡Muy útil!',true)
            }}
          >
            ¡Muy útil! <span className="f-icon icon-like" />
          </div>
          <div
            className={
              "f-fake-button f-dislike-button " +
              (tempValueLike === 2 ? "f-active" : "")
            }
            onClick={() => {
              handleLike(consultationId, 2)
              settempValueLike(2)
              viewCounsultedDatalayer('click','Podría mejorar',true)
            }}
          >
            Podría mejorar <span className="f-icon icon-like" />
          </div>
        </div>

        {!mobile && (
          <>
            <div
              className="f-nav-button f-next-button"
              onClick={() => {
                handleShowModal(currentActiveModal + 1)
              }}
            >
              <span className="icon-left f-icon" />
            </div>
            {currentActiveModal !== 0 && (
              <div
                className="f-nav-button f-back-button"
                onClick={() => {
                  handleShowModal(currentActiveModal - 1)
                }}
              >
                <span className="icon-left f-icon" />
              </div>
            )}
          </>
        )}

        <span
          className="icon2-close f-close-icon"
          onClick={() => handleCloseModal()}
        />
      </div>
    </div>
  )
}

export default ModalDetailComment
